<div class="block block-newsletter">
  <div class="block-title">
    <strong translate>Newsletter</strong>
  </div>

  <form #newsletterForm="ngForm" [formGroup]="newsLetterForm" (ngSubmit)="subscribe()">
    <label for="newsletter" class="form-title" translate>
      Sign up for our Newsletter:
    </label>
    <div
      class="input-group"
      [ngClass]="{
        'has-error':
          newsletterForm.submitted && newsLetterForm.controls.newsletter.invalid,
      }"
    >
      <input
        type="email"
        class="form-control"
        formControlName="newsletter"
        placeholder="{{ 'Enter your email address' | translate | async }}"
        required
        email
      />
      <div class="input-group-append">
        <app-speedy-button [loading]="loading()" [text]="'Subscribe'"></app-speedy-button>
      </div>
    </div>
    @if (newsletterForm.submitted && newsLetterForm.controls.newsletter.invalid) {
      @if (newsLetterForm.controls.newsletter.errors?.required) {
        <mat-error translate> This is a required field. </mat-error>
      }
      @if (
        newsLetterForm.controls.newsletter.errors?.email &&
        !newsLetterForm.controls.newsletter.errors?.required
      ) {
        <mat-error translate>
          Please enter a valid email address (Ex: johndoe&#64;domain.com).
        </mat-error>
      }
    }

    <mat-checkbox formControlName="agree">
      <app-block identifier="gdpr_text"></app-block>
    </mat-checkbox>
    @if (newsletterForm.submitted && newsLetterForm.controls.agree.invalid) {
      <mat-error translate> Please tick the checkbox to agree to the terms </mat-error>
    }
  </form>
</div>
